import React, { useState } from "react";
import Dashboard from "./Dashboard";
import "./dasboard.css";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

export default function Home() {
  const [sidebarActive, setSidebarActive] = useState(false);

  // Function to toggle the sidebar
  const toggleSidebar = () => {
    // console.log("Toggle Sidebar clicked");
    setSidebarActive(!sidebarActive);
  };
  return (
    <div className="wrapper">
      <Sidebar sidebarActive={sidebarActive} toggleSidebar={toggleSidebar} />
      <div id="content">
      <Navbar sidebarActive={sidebarActive} toggleSidebar={toggleSidebar}/>
      <Dashboard  />
      </div>
    </div>
  );
}
